// extracted by mini-css-extract-plugin
module.exports = {"primary":"#228b22","primaryDark":"#097909"};